import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryAddCargoExitChangeRideEvent } from "../../../../common/types/order-details-history-change-ride-event";

type OrderDetailsHistoryEntryChangeRideContentAddCargoExitProps = {
  event: OrderDetailsHistoryEntryAddCargoExitChangeRideEvent;
};

const OrderDetailsHistoryEntryChangeRideContentAddCargoExitComponent: FC<
  OrderDetailsHistoryEntryChangeRideContentAddCargoExitProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .addCargoExit;

  return (
    <div className="order_details_history_entry_list_item_content__section">
      <div className="order_details_history_entry_list_item_content__label">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryChangeRideContentAddCargoExitComponent;
